/*
|--------------------------------------------------------------------------
| App.JS
|
| Import statements must go at the top before any other code
|--------------------------------------------------------------------------
*/

// Automatically includes JS from the /components dirctory
import autoTemplateComponent from './core/auto-template-component'
import mobileMenu from './utilities/menu'

window.addEventListener('DOMContentLoaded', () => {
  autoTemplateComponent()
  mobileMenu()
})

if (document.getElementById('js-vacancies-feed')) {
  import('@/components/vacancies-feed/index.js').then((component) => {
    if (component?.render) {
      component.render()
    }
  })
}
